//@ts-nocheck
import React, { useState } from "react";
import PropTypes from "prop-types";
import { showPopupFlag } from "lib/actions/userInterface";
import UserAPI from "lib/api/users";
import handlePopupFlagError from "lib/errors/handlePopupFlagError";
import store from "store";
import { PrimaryButton, SecondaryButton } from "components/Buttons";
import { TextAreaInput, TextInput } from "components/Input";
import FieldGroup from "components/form/FieldGroup/FieldGroup";
import { Modal, ModalContent, ModalFooter, ModalHeader } from "components/modals/Modal";
import { VSpace } from "components/shared";
import style from "./RootModal/modal.module.scss";

const CreateRoleModal = ({ modal, onClose }) => {
  const { onSuccess } = modal.props;
  const [values, setValues] = useState({ name: "", description: "" });
  const [submitting, isSubmitting] = useState(false);

  const handleChange = (name, value) => {
    setValues((values) => ({ ...values, [name]: value }));
  };

  const handleSubmit = async (event) => {
    isSubmitting(true);
    try {
      event.preventDefault();
      const report = await UserAPI.createRole({
        ...values,
      });
      store.dispatch(
        showPopupFlag({
          appearance: "success",
          title: "Created Role",
        }),
      );
      onClose();
      onSuccess && onSuccess(report);
    } catch (err) {
      handlePopupFlagError(err);
    }
    isSubmitting(false);
  };

  const valid = values.name;

  return (
    <Modal className={style.genericModal}>
      <ModalHeader title="Create a new role" />
      <ModalContent>
        <VSpace>
          <FieldGroup label="Name">
            <TextInput
              input={{
                name: "name",
                placeholder: "Enter role name",
                autoFocus: true,
              }}
              value={values.name}
              onChange={handleChange}
            />
          </FieldGroup>
          <FieldGroup label="Description">
            <TextAreaInput
              input={{
                name: "description",
                placeholder: "Enter role describe",
              }}
              value={values.description}
              onChange={handleChange}
            />
          </FieldGroup>
        </VSpace>
      </ModalContent>
      <ModalFooter>
        <PrimaryButton disabled={!valid || submitting} onClick={handleSubmit}>
          Create role
        </PrimaryButton>
        <SecondaryButton onClick={onClose}>Cancel</SecondaryButton>
      </ModalFooter>
    </Modal>
  );
};

CreateRoleModal.defaultProps = {};

CreateRoleModal.propTypes = {
  className: PropTypes.string,
};

export default CreateRoleModal;
